import { tableAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

export const tableTheme = createMultiStyleConfigHelpers(
  tableAnatomy.keys,
).defineMultiStyleConfig({
  baseStyle: {
    thead: {
      bgColor: "gray.50",
    },
    th: {
      textTransform: "unset",
      color: "gray.600",
    },
    td: {
      color: "gray.700",
      whiteSpace: "normal",
    },
  },
  variants: {
    simple: {
      th: {
        borderColor: "gray.200",
        fontSize: "sm",
        fontWeight: "medium",
        py: 3.5,
      },
      td: {
        borderColor: "gray.200",
      },
    },
  },
});
